import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import Session from '../../utils/session';
import { ROUTER_BASE_PATH } from '../../constants/siteConstants';

// Set the expiration time in minutes
const MINUTES_BEFORE_EXPIRATION = 5;

const Timer = ({ showWarningModal, renewToken, logoutUser }) => {
  const navigate = useNavigate();

  useEffect(() => {
    const millisecondsToExpireSession = Session.getMillisecondsToExpire(MINUTES_BEFORE_EXPIRATION);
    let intervalTimer = null;

    if (millisecondsToExpireSession > 0) {
      intervalTimer = setInterval(() => {
        showWarningModal(renewToken, logoutUser, intervalTimer, navigate);
      }, millisecondsToExpireSession);
    } else {
      logoutUser();
      navigate(ROUTER_BASE_PATH);
    }

    return () => {
      if (intervalTimer) {
        clearInterval(intervalTimer);
      }
    };
  }, []);

  return <></>;
};

export default Timer;
